import type { Flag } from '~/shared/api/data-ingestion-api/client'

/** Returns the first pending flag with flag_type === 'patient_claim' and matching patient_claim_key metadata. */
export function getActiveClaimFlag(flags: Flag[], claimKey: string): Flag | null {
  return (
    flags.find(
      (flag) =>
        flag.flag_type === 'patient_claim' &&
        flag.flag_status === 'pending' &&
        (flag.metadata as Record<string, unknown>)?.patient_claim_key === claimKey,
    ) ?? null
  )
}
